var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-pie-style" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "绘图区域" } },
            [
              _c(
                "style-sub-item",
                { attrs: { title: "配色设置" } },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "c-pie-style-themes" },
                      _vm._l(_vm.dataList, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "c-pie-style-theme" },
                          [
                            _c("el-color-picker", {
                              on: {
                                change: function ($event) {
                                  return _vm.handleChange(item)
                                },
                              },
                              model: {
                                value: item[_vm.customKey + "seriesColor"],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item,
                                    _vm.customKey + "seriesColor",
                                    $$v
                                  )
                                },
                                expression: "item[customKey + 'seriesColor']",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(item[_vm.customKey + "text"])),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  {
                    staticClass: "chart-form-item-warp",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("透明度"),
                    ]),
                    _vm._v(" "),
                    _c("el-slider", {
                      staticStyle: { flex: "1" },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .columnBackgroundOpacity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "columnBackgroundOpacity",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.columnBackgroundOpacity",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("legend-style", {
            attrs: {
              config: _vm.selectItem.styleConfig.commongConfig.legendConfig,
            },
          }),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            { attrs: { title: "数据标签" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("是否开启"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value:
                            _vm.selectItem.styleConfig.commongConfig.labelConfig
                              .show,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig,
                              "show",
                              $$v
                            )
                          },
                          expression:
                            "selectItem.styleConfig.commongConfig.labelConfig.show",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.showAll,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig,
                                "showAll",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.showAll",
                          },
                        },
                        [_vm._v("全量显示")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "chart-form-item-warp" }, [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("内容"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig.labelConfig
                            .pieContent,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig
                              .labelConfig,
                            "pieContent",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.labelConfig.pieContent",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "dim" } }, [
                        _vm._v("维度"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "measure" } }, [
                        _vm._v("度量"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "percent" } }, [
                        _vm._v("占比"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("位置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            "popper-class": "c-select-style-popper",
                          },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.position,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig,
                                "position",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.position",
                          },
                        },
                        _vm._l(
                          _vm.selectItem.type === "Pie"
                            ? _vm.pieLabelPositionOptions
                            : _vm.labelPositionOptions,
                          function (option) {
                            return _c("el-option", {
                              key: option.value,
                              attrs: {
                                label: option.label,
                                value: option.value,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "text-style",
                    {
                      attrs: {
                        config:
                          _vm.selectItem.styleConfig.commongConfig.labelConfig
                            .textConfig,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v(
                              "\n              占比小数位数\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                "popper-class": "c-select-style-popper",
                              },
                              model: {
                                value:
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig.decimalPlaces,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectItem.styleConfig.commongConfig
                                      .labelConfig.textConfig,
                                    "decimalPlaces",
                                    $$v
                                  )
                                },
                                expression:
                                  "selectItem.styleConfig.commongConfig.labelConfig.textConfig.decimalPlaces",
                              },
                            },
                            _vm._l(_vm.decimalPlacesOptions, function (option) {
                              return _c("el-option", {
                                key: option.value,
                                attrs: {
                                  label: option.label,
                                  value: option.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }